import axios from "axios";
axios.defaults.baseURL = "https://ehs-msr-successor-api.azurewebsites.net/api/";
